import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

const loadingText = 'Loading...';

@Component({
    selector: 'app-sensitive-string',
    templateUrl: './sensitive-string.component.html',
    styleUrls: ['./sensitive-string.component.scss'],
    imports: [NgClass, MatIcon]
})
export class SensitiveStringComponent implements OnInit {
  @Output() valueAccessed: EventEmitter<string> = new EventEmitter<string>();
  @Input() value: string;
  @Input() hiddenTextLength = 10;
  @Input() hiddenTextCharacter = '∗'; // Low asterisk

  visible = false;
  hiddenTextString: string;
  hiddenTextWidth: number;
  hiddenTextHeight: number;
  valueLoading: string;

  ngOnInit() {
    this.hiddenTextString = this.hiddenTextCharacter.repeat(this.hiddenTextLength);
    this.valueLoading = loadingText;
  }

  public toggleVisibility($event): void {
    $event.preventDefault();

    this.visible = !this.visible;

    if (this.visible) {
      this.valueAccessed.emit();
    }
  }
}
